<template>
  <div>
    <Navbar type="bg-transparent-sticky" />
    <div class="hero-container-thin">
      <div class="hero-opacity"></div>
      <img class="hero-image" src="../assets/gdq_hero.jpg" alt="hero image" />
    </div>
    <Breadcrumb />
    <div class="border-0 mx-auto container-xl pb-4 mb-4">
      <div class="title-area mb-4 pb-4">
        <h1 class="page-title h2 mb-0">
          {{ surveytype_name }} Report for {{ survey && survey.survey_name }}
        </h1>
      </div>

      <div v-show="Number(report_loaded) === 1" class="mx-auto">
        <div v-if="google_file_id" class="row mb-4">
          <div class="mx-auto col-10 col-lg-8" style="border: 1px solid #ddd; border-radius: 4px; overflow: hidden;">
            <iframe
              :src="'https://drive.google.com/file/d/' + google_file_id + '/preview'"
              width="100%"
              height="600"
              frameborder="0"
              style="border: none;"
              allowfullscreen
            ></iframe>
          </div>
        </div>
        <div v-if="google_embed_loading" class="row mb-4">
          <div class="text-center py-5">
            <h5>
              <span class="spinner-border spinner-border-sm align-middle text-primary me-2" role="status">
                <span class="visually-hidden">Loading...</span>
              </span>
              Loading report preview...
            </h5>
          </div>
        </div>
        <div class="row mb-4">
          <button
            type="button"
            class="btn btn-primary mx-auto large col-4"
            @click.prevent="report_download"
          >
            Download report
          </button>
        </div>
        <div class="row mb-4" v-if="is_v2_enabled">
          <button
            type="button"
            class="btn btn-info mx-auto large col-4"
            @click.prevent="report_download_v2"
          >
            Download report v2
          </button>
        </div>
        <div class="row mb-4" v-if="survey && Number(survey.survey_type_id) === 1 && !show_limited">
          <button
            type="button"
            class="btn btn-secondary mx-auto large col-4"
            @click.prevent="rawdata_excel_download"
          >
            Download raw data Excel
          </button>
        </div>
        <div
          class="row mb-4"
          v-if="survey && Number(survey.survey_type_id) === 1 && show_limited === true"
        >
          <button
            type="button"
            class="btn btn-danger mx-auto large col-4"
            @click.prevent="rawdata_excel_download_limited"
          >
            Download raw data Excel Limited
          </button>
        </div>
        <div
          class="row mb-4"
          v-if="survey && Number(survey.addon_survey) > 0"
        >
          <button
            type="button"
            class="btn btn-success mx-auto large col-4"
            @click.prevent="addonsurvey_excel_download"
          >
            Download add-on
          </button>
        </div>
        <div class="row">
          <button
            type="button"
            class="btn btn-warning mx-auto large col-4"
            @click.prevent="receipt_download"
          >
            Download payment receipt
          </button>
        </div>
        <div class="row">
          <button
            type="button"
            class="btn btn-secondary mx-auto large col-4 mt-4"
            @click.prevent="back_to_survey"
          >
            Back to survey page
          </button>
        </div>
      </div>

      <div
        v-show="Number(report_paid) === 1 && Number(report_loaded) === 0"
        class="align-center text-center mx-auto col-12"
      >
        <h2 class="align-center">
          Generating report...
        </h2>
      </div>

      <div v-show="Number(invoice_status) === 2 && Number(report_loaded) === 0">
        <h2 class="align-center">
          <span
            class="spinner-border spinner-border-sm align-middle text-primary me-2"
            role="status"
            aria-hidden="true"
          >
            <span class="visually-hidden">Loading...</span>
          </span>
          Preparing report...
        </h2>
      </div>

      <div
        v-if="Number(invoice_status) === 0 && Number(report_loaded) === 0 && Number(report_paid) === 0"
        class="mx-auto col-12"
      >
        <h4>Report Invoice</h4>
        <table id="invoiceheadtable" class="table b-table mb-4">
          <thead class="hidden_header">
            <tr>
              <th></th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, idx) in invoicehead" :key="`head-${idx}`">
              <td>{{ item.label }}</td>
              <td class="text-end">{{ item.value }}</td>
            </tr>
          </tbody>
        </table>
        <table id="invoicedetailstable" class="table b-table">
          <thead>
            <tr>
              <th>Survey Member</th>
              <th class="text-end">Price</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, idx) in invoicedetails" :key="`detail-${idx}`">
              <td>{{ item.item_text }}</td>
              <td class="text-end">{{ item.price }}</td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <td>
                TOTAL SUM<br>
                <strong>VAT</strong><br>
                <strong>TOTAL SUM INCLUDING VAT</strong>
              </td>
              <td class="text-end">
                {{ invoice.invoice_amount }} SEK<br>
                <strong>{{ invoice.invoice_vat_amount }} SEK</strong><br>
                <strong>{{ invoice.invoice_amount_inc_vat }} SEK</strong>
              </td>
            </tr>
          </tfoot>
        </table>

        <div class="justify-content-center text-center d-flex pb-2">
          <strong>Contact information:&nbsp;&nbsp;</strong>GDQ Associates AB, e-mail:&nbsp;&nbsp;<a href="mailto: gdq@gdq.se">gdq@gdq.se</a>, telephone: +46 76 052 52 03
        </div>
        <div class="justify-content-center text-center d-flex pb-2">
          <a href="https://gdq.se/en/privacypolicy/">Click here to view our privacy policy</a>
        </div>

        <div class="bg-warning px-4 pt-4">
          <div class="form-check pb-4">
            <input
              id="invoice-accept"
              v-model="invoice_accept"
              type="checkbox"
              class="form-check-input"
              @input="invoice_updateinfo"
            >
            <label class="form-check-label" for="invoice-accept">
              <strong>
                I accept the
                <a
                  href="https://gdq.se/en/terms-of-purchase/"
                  target="_new"
                >
                  terms of purchase
                </a> and the charges as specified above
              </strong>
            </label>
          </div>
        </div>

        <div v-if="invoice_accept" class="mt-3">
          <label class="form-label">I want to pay by;</label>
          <div class="row justify-content-center">
            <div class="col-auto" v-if="canpayInvoice()">
              <button
                type="button"
                class="btn btn-primary mx-2"
                @click="payment = '2'"
              >
                Invoice
              </button>
            </div>
            <div class="col-auto" v-if="coupons > 0">
              <button
                type="button"
                class="btn btn-primary mx-2"
                @click="payment = '3'"
              >
                Coupon
              </button>
            </div>
            <div class="col-auto">
              <button
                type="button"
                class="btn btn-primary mx-2"
                @click="payment = '4'"
              >
                Credit Card
              </button>
            </div>
          </div>
        </div>

        <div v-if="Number(payment) === 2 || Number(payment) === 4" class="mt-4">
          <h4 class="mt-2">
            {{ Number(payment) === 2 ? 'Invoice payment' : 'Card payment - billing details' }}
          </h4>
          <div class="mb-3 pb-4 mb-4" v-if="Number(payment) === 2">
            <label class="form-label">I want to receive my invoice by:</label>
            <select
              v-model="e_invoice"
              class="form-select"
              @change="invoice_updateinfo"
            >
              <option v-for="option in einvoiceoptions" :key="option.value" :value="option.value">
                {{ option.text }}
              </option>
            </select>
          </div>
          <div class="mb-3" v-if="Number(payment) === 2">
            The invoice will be sent to the address you provide below. If you already have a link to e-invoices via your organisation, the invoice will be sent via that route. As a part of our environmental management, we encourage digital invoices. Enter your e-mail if you want to receive the invoice by e-mail.
          </div>
          <h5 class="mt-4">Payee information</h5>

          <div class="row mb-3">
            <label class="col-sm-4 col-form-label">
              Invoice Reference <b>
                <span v-if="invoice_reference===''" class="text-danger">required</span>
              </b>
            </label>
            <div class="col-sm-8">
              <input
                :class="`${anon ? 'g-anon' : '' } form-control`"
                v-model="invoice_reference"
                placeholder="Invoice reference"
                @input="invoice_updateinfo"
              >
            </div>
          </div>

          <div class="row mb-3">
            <label class="col-sm-4 col-form-label">
              Name <b>
                <span v-if="invoice_name===''" class="text-danger">required</span>
              </b>
            </label>
            <div class="col-sm-8">
              <input
                :class="`${anon ? 'g-anon' : '' } form-control`"
                v-model="invoice_name"
                placeholder="Name"
                @input="invoice_updateinfo"
              >
            </div>
          </div>

          <div class="row mb-3">
            <label class="col-sm-4 col-form-label">E-mail</label>
            <div class="col-sm-8">
              <input
                :class="`${anon ? 'g-anon' : '' } form-control`"
                v-model="invoice_email"
                placeholder="Invoice e-mail"
                @input="invoice_updateinfo"
              >
            </div>
          </div>

          <div class="row mb-3">
            <label class="col-sm-4 col-form-label">
              Company <b>
                <span v-if="invoice_company===''" class="text-danger">required</span>
              </b>
            </label>
            <div class="col-sm-8">
              <input
                :class="`${anon ? 'g-anon' : '' } form-control`"
                v-model="invoice_company"
                placeholder="Company name"
                @input="invoice_updateinfo"
              >
            </div>
          </div>

          <div class="row mb-3">
            <label class="col-sm-4 col-form-label">Address</label>
            <div class="col-sm-8">
              <input
                :class="`${anon ? 'g-anon' : '' } form-control`"
                v-model="invoice_address_1"
                placeholder="Address line 1"
                @input="invoice_updateinfo"
              >
            </div>
          </div>

          <div class="row mb-3">
            <div class="offset-sm-4 col-sm-8">
              <input
                :class="`${anon ? 'g-anon' : '' } form-control`"
                v-model="invoice_address_2"
                placeholder="Address line 2"
                @input="invoice_updateinfo"
              >
            </div>
          </div>

          <div class="row mb-3">
            <label class="col-sm-4 col-form-label">Zip code</label>
            <div class="col-sm-8">
              <input
                :class="`${anon ? 'g-anon' : '' } form-control col-3`"
                v-model="invoice_zip_code"
                maxlength="6"
                placeholder="Zip code"
                @input="invoice_updateinfo"
              >
            </div>
          </div>

          <div class="row mb-3">
            <label class="col-sm-4 col-form-label">City</label>
            <div class="col-sm-8">
              <input
                :class="`${anon ? 'g-anon' : '' } form-control`"
                v-model="invoice_city"
                placeholder="City"
                @input="invoice_updateinfo"
              >
            </div>
          </div>

          <div class="row mb-3">
            <label class="col-sm-4 col-form-label">
              VAT number/social security number <b>
                <span v-if="invoice_company_regno===''" class="text-danger">required</span>
              </b>
            </label>
            <div class="col-sm-8">
              <input
                :class="`${anon ? 'g-anon' : '' } form-control`"
                v-model="invoice_company_regno"
                placeholder="VAT number/social security number"
                @input="invoice_updateinfo"
              >
              <div class="form-text">
                Fill out the VAT number (organisationsnummer) if the invoice should be issued to an organisation. If you wish to receive the invoice as a private individual, fill out your social security number (personnummer).
              </div>
            </div>
          </div>
        </div>

        <div v-if="Number(payment) === 2 && formok" class="text-end my-4 py-4">
          <button
            type="button"
            class="btn btn-primary btn-lg"
            @click.prevent="invoice_save"
          >
            <span class="icon-file-presentation me-2 pe-1"></span>
            Continue to the Report
          </button>
        </div>

        <div v-if="Number(payment) === 3" class="my-4 pb-4">
          <label class="form-label">Please enter your coupon code</label>
          <div class="input-group">
            <input
              v-model="coupon_code"
              :class="`form-control ${couponok !== false ? '' : 'is-invalid'}`"
            >
            <button
              type="button"
              class="btn btn-primary btn-small pb-1 pt-1 btn-coupon"
              :disabled="coupon_code === ''"
              @click.prevent="checkcoupon()"
            >
              <span>
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 512 512"
                  focusable="false"
                  class="white fa-icon"
                >
                  <path
                    d="M173.9 439.4l-166.4-166.4c-10-10-10-26.2 0-36.2l36.2-36.2c10-10 26.2-10 36.2 0l112.1 112.1 240.1-240.1c10-10 26.2-10 36.2 0l36.2 36.2c10 10 10 26.2 0 36.2l-294.4 294.4c-10 10-26.2 10-36.2 0z"
                  />
                </svg>
              </span>
              Use the coupon
            </button>
          </div>
          <div v-if="couponok === false" class="alert alert-danger mt-2 mb-0">
            Invalid coupon
          </div>
        </div>

        <div v-if="Number(payment) === 1" class="my-4 pb-4">
          <h5>Card Payment</h5>
          <div class="py-4 col-12 text-center align-center">
            Payment service provided by DIBS<br>
            <img
              class="ms-4"
              src="https://cdn.dibspayment.com/logo/checkout/combo/horiz/DIBS_checkout_kombo_horizontal_04.png"
              alt="DIBS - Payments made easy"
              width="270"
            >
          </div>
          <form
            id="gdq_dibsform"
            ref="gdq_dibsform"
            class="text-center align-center"
            method="post"
            action="https://payment.architrade.com/paymentweb/start.action"
          >
            <input
              type="hidden"
              name="amount"
              :value="invoice.dibs_amount * 100"
            >
            <input
              type="hidden"
              name="currency"
              value="SEK"
            >
            <input
              type="hidden"
              name="lang"
              value="en"
            >
            <input
              type="hidden"
              name="capturenow"
              value="yes"
            >
            <input
              type="hidden"
              name="decorator"
              value="responsive"
            >
            <input
              type="hidden"
              name="merchant"
              value="90219297"
            >
            <input
              type="hidden"
              name="orderid"
              :value="order_id"
            >
            <input
              type="hidden"
              name="ordertext"
              :value="invoice.invoice_text"
            >
            <input
              type="hidden"
              name="accepturl"
              :value="accept_url"
            >
            <input
              type="hidden"
              name="callbackurl"
              :value="callback_url"
            >
            <input
              type="hidden"
              name="cancelurl"
              :value="cancel_url"
            >
            <input
              type="hidden"
              name="gdqurl"
              :value="gdq_url"
            >
            <input
              v-if="Number(consultant_id) === 1"
              type="hidden"
              name="test"
              value="test"
            >
            <button
              type="button"
              class="btn btn-primary btn-lg"
              :disabled="invoice_accept===false"
              @click.prevent.stop="dibs_payment"
            >
              <span class="icon-receipt me-2 pe-1"></span>
              Continue to DIBS Payment
            </button>
          </form>
        </div>

        <div v-if="Number(payment) === 4 && invoice_accept" class="my-4">
          <button
            type="button"
            class="btn btn-primary btn-lg mx-auto d-block mb-3"
            @click.prevent="startNetsPayment"
          >
            <span class="icon-receipt me-2 pe-1"></span>
            Continue to Nets Payment
          </button>
          <div style="display:none">
            <NetsPayment
              ref="netsPayment"
              product-name="GDQ Report"
              :dibs-amount="invoice.dibs_amount"
              :order-id="order_id"
              :accept-url="web_url"
              :cancel-url="web_url"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Navbar from './Navbar'
import Breadcrumb from './Breadcrumb'
import NetsPayment from './NetsPayment'
import { config } from '../../config'

export default {
  name: 'GroupSurveyReport',
  components: {
    Navbar,
    Breadcrumb,
    NetsPayment
  },
  data () {
    return {
      addressdone: false,
      consultant_id: this.$store.state.user_id,
      survey_id: 0,
      survey: null,
      surveytype_name: 'GDQ',
      survey_stage_id: 0,
      surveystages: [],
      invoice_status: 2,
      order_id: '0',
      invoice_id: '0',
      invoice: null,
      invoicehead: [],
      invoiceheadfields: [
        { key: 'label', label: '' },
        { key: 'value', label: '', tdClass: 'align-right text-right' }
      ],
      invoicedetails: [],
      invoicedetailsfields: [
        { key: 'item_text', label: 'Survey Member', sortable: false },
        {
          key: 'price',
          label: 'Price',
          sortable: false,
          thClass: 'align-right text-right',
          tdClass: 'align-right text-right'
        }
      ],
      invoice_reference: '',
      invoice_name: '',
      invoice_email: '',
      invoice_company: '',
      invoice_address_1: '',
      invoice_address_2: '',
      invoice_zip_code: '',
      invoice_city: '',
      invoice_company_regno: '',
      e_invoice: 1,
      einvoiceoptions: [
        // { 'value': '0', text: 'Paper invoice sent by post' },
        { 'value': '1', text: 'PDF invoice sent by e-mail' },
        { 'value': '2', text: 'E-invoice' }
      ],
      coupon_id: 0,
      coupon_code: '',
      couponok: null,
      invoice_accept: false,
      formok: false,
      payment: null,
      base_url: config.base_url,
      report_id: 0,
      report_v2_id: 0,
      report_paid: 0,
      report_loaded: 0,
      google_file_id: '',
      google_embed_loading: false,
      web_url: window.location + '',
      coupons: 0,
      spotify: '0',
      netspayment_id: this.$route.query.paymentid ? this.$route.query.paymentid : '',
      nets_paid_amount: 0,
      nets_invoice_amount: 0,
    }
  },
  computed: {
    anon: function () {
      return this.$store.state.anon
    },
    gdq_url: function () {
      const url = window.location
      return url
    },
    is_v2_enabled: function () {
      return ['stage', 'test'].includes(config.mode)
    },
    show_limited: function () {
      const cs = this.$store.state.profile.consultantstatus_id
      return cs === 5 || cs === '5'
    }
  },
  async created () {
    await this.checknetspayment().then(() => {
      this.coupons_get()
      this.groupsurvey_get()
      this.invoice_get()
    })
  },
  methods: {
    canpayInvoice () {
      let ok = true
      if ([875, 3068, 996, 1074, 1863].includes(this.consultant_id)) {
        ok = false
      }
      if (this.$store.state.user.email.includes('vectorgroup')) {
        ok = false
      }
      return ok
    },
    async checknetspayment () {
      if (this.netspayment_id !== '') {
        // Update the invoice and payment
        await this.$store.dispatch('netspayment_update', { paymentId: this.netspayment_id })
          .then((resp) => {
            if (resp.data.status === 'OK') {
            // Remove paymentID
              this.$router.push(this.$route.path)
            } else {
              alert(resp.data.error)
            }
          })
      }
    },
    back_to_survey () {
      this.$router.push('/group/survey')
    },
    coupons_get () {
      const filter = {
        consultant_id: {
          operator: '==',
          value: this.$store.state.user_id
        },
        coupon_invoice_id: {
          operator: '=',
          value: 0
        }
      }
      this.$store
        .dispatch('records_readall', {
          table_name: 'g_consultant_coupons',
          filter: filter
        })
        .then(result => {
          this.coupons = result.data.result.length
        })
    },
    dibs_payment () {
      const payload = { invoice_id: this.invoice_id, payment_method_id: 1 }
      this.$store.dispatch('paymentlog_create', payload).then(() => {
        // ---------------------
        // Here we POST to DIBS
        // ---------------------
        this.$refs.gdq_dibsform.submit()
      })
    },
    report_download () {
      const reporturl = config.report_url + '/gdq_report.php?r=' + this.report_id
      const downloadURL = new URL(reporturl)
      const downloadLink = document.createElement('a')
      downloadLink.href = downloadURL
      downloadLink.setAttribute(
        'download',
        'GDQ_Report_' +
          this.survey_id +
          '_' +
          new Date().toISOString().split('T')[0]
      )
      document.body.appendChild(downloadLink)
      downloadLink.click()
    },
    async report_download_v2 () {
      // Generate v2 report first if needed
      let v2_action = 'gdqreport_create_v2'
      if (Number(this.survey.survey_type_id) === 2) {
        v2_action = 'gdqshortreport_create_v2'
      }
      await this.$store
        .dispatch(v2_action, { survey_id: this.survey_id })
        .catch(err => {
          console.error('V2 report generation failed:', err)
        })

      const reporturl = config.report_url + '/gdq_report.php?r=' + this.report_v2_id + '&v2=true'
      const downloadURL = new URL(reporturl)
      const downloadLink = document.createElement('a')
      downloadLink.href = downloadURL
      downloadLink.setAttribute(
        'download',
        'GDQ_Report_v2_' +
          this.survey_id +
          '_' +
          new Date().toISOString().split('T')[0]
      )
      document.body.appendChild(downloadLink)
      downloadLink.click()
    },
    generate_v2_report () {
      if (!this.is_v2_enabled) {
        return
      }
      this.google_embed_loading = true
      let v2_action = 'gdqreport_create_v2'
      if (Number(this.survey.survey_type_id) === 2) {
        v2_action = 'gdqshortreport_create_v2'
      }
      this.$store
        .dispatch(v2_action, { survey_id: this.survey_id })
        .then(resp => {
          this.report_v2_id = resp.data.id
          return this.$store.dispatch('google_drive_upload', { report_id: this.report_v2_id })
        })
        .then(uploadResp => {
          if (uploadResp && uploadResp.data && uploadResp.data.google_file_id) {
            this.google_file_id = uploadResp.data.google_file_id
          }
        })
        .catch(err => {
          console.error('V2 report or upload failed:', err)
        })
        .finally(() => {
          this.google_embed_loading = false
        })
    },
    rawdata_download () {
      this.$store
        .dispatch('gdqreport_rawdata_get', { survey_id: this.survey_id })
        .then(resp => {
          const byteCharacters = atob(resp.data)
          const byteNumbers = new Array(byteCharacters.length)
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i)
          }
          const byteArray = new Uint8Array(byteNumbers)
          const blob = new Blob([byteArray], { type: 'application/pdf' })
          const fileURL = window.URL.createObjectURL(blob)
          const fileLink = document.createElement('a')
          fileLink.href = fileURL
          fileLink.setAttribute(
            'download',
            'GDQ_RawData_' +
              this.survey_id +
              '_' +
              new Date().toISOString().split('T')[0]
          )
          document.body.appendChild(fileLink)
          fileLink.click()
        })
    },
    rawdata_excel_download () {
      this.$store
        .dispatch('gdqreport_rawdata_excel_get', {
          survey_id: this.survey_id,
          full: 1 })
        .then(resp => {
          const blob = new Blob([resp.data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          })

          const fileURL = window.URL.createObjectURL(blob)
          const fileLink = document.createElement('a')
          fileLink.href = fileURL
          fileLink.setAttribute(
            'download',
            `GDQ_RawData_${this.survey_id}_${new Date().toISOString().split('T')[0]}.xlsx`
          )
          document.body.appendChild(fileLink)
          fileLink.click()
          document.body.removeChild(fileLink)
          window.URL.revokeObjectURL(fileURL)
        })
    },
    rawdata_excel_download_limited () {
      this.$store
        .dispatch('gdqreport_rawdata_excel_get', {
          survey_id: this.survey_id,
          full: 0 })
        .then(resp => {
          const blob = new Blob([resp.data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          })

          const fileURL = window.URL.createObjectURL(blob)
          const fileLink = document.createElement('a')
          fileLink.href = fileURL
          fileLink.setAttribute(
            'download',
            `GDQ_RawData_Limited_s${this.survey_id}_${new Date().toISOString().split('T')[0]}.xlsx`
          )
          document.body.appendChild(fileLink)
          fileLink.click()
          document.body.removeChild(fileLink)
          window.URL.revokeObjectURL(fileURL)
        })
    },
    addonsurvey_excel_download () {
      this.$store
        .dispatch('gdq_addonsurvey_exportexcel', {
          survey_id: this.survey_id
        })
        .then(resp => {
          const blob = new Blob([resp.data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          })

          const fileURL = window.URL.createObjectURL(blob)
          const fileLink = document.createElement('a')
          fileLink.href = fileURL
          fileLink.setAttribute(
            'download',
            `GDQ_AddOn_${this.survey_id}_${new Date().toISOString().split('T')[0]}.xlsx`
          )
          document.body.appendChild(fileLink)
          fileLink.click()
          document.body.removeChild(fileLink)
          window.URL.revokeObjectURL(fileURL)
        })
    },

    receipt_download () {
      this.$store
        .dispatch('gdqreport_receipt_create', { survey_id: this.survey_id })
        .then(resp => {
          const byteCharacters = atob(resp.data)
          const byteNumbers = new Array(byteCharacters.length)
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i)
          }
          const byteArray = new Uint8Array(byteNumbers)
          const blob = new Blob([byteArray], { type: 'application/pdf' })
          const fileURL = window.URL.createObjectURL(blob)
          const fileLink = document.createElement('a')
          fileLink.href = fileURL
          fileLink.setAttribute(
            'download',
            'GDQ_Receipt_' +
              this.survey_id +
              '_' +
              new Date().toISOString().split('T')[0]
          )
          document.body.appendChild(fileLink)
          fileLink.click()
        })
    },
    invoice_updateinfo () {
      const invoice = {
        invoice_reference: this.invoice_reference,
        invoice_name: this.invoice_name,
        invoice_company: this.invoice_company,
        invoice_address_1: this.invoice_address_1,
        invoice_address_2: this.invoice_address_2,
        invoice_zip_code: this.invoice_zip_code,
        invoice_city: this.invoice_city,
        invoice_company_regno: this.invoice_company_regno,
        invoice_email: this.invoice_email,
        e_invoice: this.e_invoice
      }
      this.$store
        .dispatch('groupsurveyinvoice_save', {
          invoice_id: this.invoice_id,
          invoice: invoice
        })
        .then(() => { this.checkform() })
    },
    invoice_save () {
      const invoice = {
        invoice_reference: this.invoice_reference,
        invoice_name: this.invoice_name,
        invoice_company: this.invoice_company,
        invoice_address_1: this.invoice_address_1,
        invoice_address_2: this.invoice_address_2,
        invoice_zip_code: this.invoice_zip_code,
        invoice_city: this.invoice_city,
        invoice_company_regno: this.invoice_company_regno,
        e_invoice: this.e_invoice,
        invoice_status: 2,
        invoice_payment_method_id: this.payment,
        coupon_id: this.coupon_id,
        invoice_email: this.invoice_email
      }
      this.$store
        .dispatch('groupsurveyinvoice_save', {
          invoice_id: this.invoice_id,
          invoice: invoice
        })
        .then(() => {
          this.report_paid = 1
          this.$nextTick(() => {
            this.$store.dispatch('groupsurveyinvoice_notifyadmin', {
              invoice_id: this.invoice_id
            })
            let action = 'gdqreport_create'
            if (Number(this.survey.survey_type_id) === 2) {
              action = 'gdqshortreport_create'
            }
            if (Number(this.survey.survey_type_id) === 3) {
              action = 'oscreport_create'
            }
            if (this.spotify === '1') {
              action = 'gdqshortreport_spotify_create'
            }
            this.$store
              .dispatch(action, { survey_id: this.survey_id })
              .then(resp => {
                this.report_id = resp.data.id
                this.report_loaded = 1
                this.generate_v2_report()
              })
          })
        })
    },
    // Save invoice contact info before redirecting to Nets card payment
    prepareNetsPayment () {
      if (!this.invoice_id || this.invoice_id <= 0) {
        return Promise.reject(new Error('Invoice not created'))
      }
      const invoice = {
        invoice_reference: this.invoice_reference,
        invoice_name: this.invoice_name,
        invoice_company: this.invoice_company,
        invoice_address_1: this.invoice_address_1,
        invoice_address_2: this.invoice_address_2,
        invoice_zip_code: this.invoice_zip_code,
        invoice_city: this.invoice_city,
        invoice_company_regno: this.invoice_company_regno,
        invoice_email: this.invoice_email,
        e_invoice: this.e_invoice,
        invoice_payment_method_id: 4,
        invoice_status: this.invoice_status
      }
      return this.$store
        .dispatch('groupsurveyinvoice_save', {
          invoice_id: this.invoice_id,
          invoice: invoice
        })
    },
    startNetsPayment () {
      this.prepareNetsPayment()
        .then(() => {
          if (this.$refs.netsPayment && this.$refs.netsPayment.nets_payment) {
            this.$refs.netsPayment.nets_payment()
          } else {
            alert('Could not start payment')
          }
        })
        .catch((err) => {
          alert('Could not start payment: ' + (err && err.message ? err.message : err))
        })
    },
    checkform () {
      this.formok = true
      if (this.invoice_name === '') {
        this.formok = false
      }
      if (this.invoice_company === '') {
        this.formok = false
      }
      if (this.invoice_company_regno === '') {
        this.formok = false
      }
      if (this.invoice_accept === false) {
        this.formok = false
      }
      if (this.invoice_reference === '') {
        this.formok = false
      }
    },
    checkcoupon () {
      this.couponok = null
      if (this.coupon_code === '') {
        this.couponok = false
        return false
      }
      const filter = {
        consultant_id: {
          operator: '=',
          value: this.$store.state.user_id
        },
        coupon_code: {
          operator: '=',
          value: this.coupon_code
        },
        coupon_invoice_id: {
          operator: '=',
          value: 0
        }
      }
      this.$store
        .dispatch('records_readall', {
          table_name: 'g_consultant_coupons',
          filter: filter
        })
        .then(resp => {
          if (resp.data.result.length !== 1) {
            this.couponok = false
          } else {
            this.coupon_id = resp.data.result[0].id
            const invoice = {
              invoice_reference: this.invoice_reference,
              invoice_name: this.invoice_name,
              invoice_company: this.invoice_company,
              invoice_address_1: this.invoice_address_1,
              invoice_address_2: this.invoice_address_2,
              invoice_zip_code: this.invoice_zip_code,
              invoice_city: this.invoice_city,
              invoice_company_regno: this.invoice_company_regno,
              invoice_status: 2,
              invoice_payment_method_id: this.payment,
              coupon_id: this.coupon_id,
              invoice_email: this.invoice_email
            }
            this.$store
              .dispatch('groupsurveyinvoice_save', {
                invoice_id: this.invoice_id,
                invoice: invoice
              })
              .then(() => {
                this.$store
                  .dispatch('record_put', {
                    table_name: 'g_consultant_coupons',
                    id: this.coupon_id,
                    record: { coupon_invoice_id: this.invoice_id }
                  })
                  .then(() => {
                    this.report_paid = 1
                    this.$nextTick(() => {
                      let action = 'gdqreport_create'
                      if (Number(this.survey.survey_type_id) === 2) {
                        action = 'gdqshortreport_create'
                      }
                      if (Number(this.survey.survey_type_id) === 3) {
                        action = 'oscreport_create'
                      }
                      if (this.spotify === '1') {
                        action = 'gdqshortreport_spotify_create'
                      }
                      this.$store
                        .dispatch(action, { survey_id: this.survey_id })
                         .then(resp => {
                           this.report_id = resp.data.id
                           this.report_loaded = 1
                           this.generate_v2_report()
                         })
                    })
                  })
              })
          }
        })
      return false
    },
    groupsurvey_get () {
      this.survey = this.$store.state.currentsurvey
      this.survey_stage_id = this.survey.survey_stage_id
      this.survey_id = this.survey.id
      this.spotify = this.survey.spotify
      this.invoice_reference = this.survey.survey_invoice_reference
      this.$store
        .dispatch('record_read', {
          table_name: 'g_surveytypes',
          id: this.survey.survey_type_id
        })
        .then(resp => {
          this.surveytype_name = resp.data.surveytype_name
        })
    },
    // ----------------------------------------------------------------
    // Get/create invoice for any unprocessed surveymembers
    // invoice_status:
    // 0 = There are invoices to be paid/handle
    // 1 = Not used
    // 2 = All invoices created and payment selected
    // report_paid:
    // 0 = We have not done the payment processing to end
    // 1 = The payment processing is finished (inv or return from DIBS)
    // report_loaded:
    // 0 = The report has not been loaded
    // 1 = The report has been loaded
    // ----------------------------------------------------------------
    invoice_get () {
      this.$store
        .dispatch('groupsurveyinvoice_fetch', { survey_id: this.survey.id })
        .then(resp => {
          this.invoice_id = resp.data.invoice_id
          this.invoice = resp.data.invoice || {}
          this.order_id = 1000000 + parseInt(this.invoice_id)
          // We found or just generated an unpaid invoice
          if (this.invoice_id > 0) {
            this.invoice_status = resp.data.invoice.invoice_status
            this.invoicedetails = resp.data.invoice.invoicedetails
            this.invoicehead.push({ label: 'Invoice Number', value: resp.data.invoice.invoice_number })
            this.invoicehead.push({ label: 'Seller', value: 'GDQ Associates AB' })
            this.invoicehead.push({ label: 'Organisation number', value: '556995-0016' })
            this.invoicehead.push({ label: 'Invoice Date', value: resp.data.invoice.invoice_date })
            this.invoicehead.push({ label: 'Invoice Reference', value: resp.data.invoice.invoice_reference })
            this.invoice.dibs_amount = this.invoice.invoice_amount_inc_vat.replace(',', '')
          } else {
            this.invoice_status = 2
          }
          // Prefill invoice fields from current or previous invoice, but allow user edits
          const previousInvoice = resp.data.previous_invoice || {}
          const preferValue = (key, fallback) => {
            if (!this[key] || this[key] === '') {
              if (this.invoice && this.invoice[key]) {
                this[key] = this.invoice[key]
              } else if (previousInvoice[key]) {
                this[key] = previousInvoice[key]
              } else if (fallback !== undefined) {
                this[key] = fallback
              }
            }
          }
          preferValue('invoice_reference')
          preferValue('invoice_name')
          preferValue('invoice_company')
          preferValue('invoice_address_1')
          preferValue('invoice_address_2')
          preferValue('invoice_zip_code')
          preferValue('invoice_city')
          preferValue('invoice_company_regno')
          preferValue('invoice_email')
          preferValue('e_invoice', 1)
          // -----------------------------------------------------------------
          // The invoice id returned is the newly created invoice id (if any)
          // If invoice_id = 0, we have already created all invoices required
          // and thus can display the report, otherwise, we do nothing
          // This gives us a challenge if the consultant backs out and then
          // comes back again. Hmmmmmmm
          // -----------------------------------------------------------------
          if (Number(this.invoice_status) === 2) {
            let action = 'gdqreport_create'
            if (Number(this.survey.survey_type_id) === 2) {
              action = 'gdqshortreport_create'
            }
            if (Number(this.survey.survey_type_id) === 3) {
              action = 'oscreport_create'
            }
            if (this.spotify === '1') {
              action = 'gdqshortreport_spotify_create'
            }
            this.$store
              .dispatch(action, { survey_id: this.survey_id })
              .then(resp => {
                this.report_id = resp.data.id
                this.report_paid = 1
                this.report_loaded = 1
                this.generate_v2_report()
              })
            // })
          }
        })
    }
  }
}
</script>
<style scoped></style>
<style>
.hidden_header {
  display: none;
}
.btn-coupon {
  border-radius: 0px !important;
}
</style>
